<section
	*ngIf="showSidenav"
	[ngClass]="{ 'expanded-menu': expandMenu, 'rail-collapsed': railCollapsed }"
	class="side-nav closed"
>
	<mat-sidenav
		#sidenav
		role="navigation"
		mode="side"
		[opened]="true"
		[disableClose]="true"
	>
		<div
			[ngClass]="{ 'no-menu-margin': !dropdownIsVisible }"
			[@.disabled]="reduceMotion"
			class="menu-list"
		>
			<!--
				The way back to the old density. 240px is what makes a
				destination readable; it is also 150px a wide table does not
				have, so the rail has to be able to give it back.
			-->
			<div class="rail-head">
				<button
					#railSearch
					type="button"
					class="rail-search"
					aria-haspopup="dialog"
					[attr.aria-keyshortcuts]="searchShortcut"
					(click)="openSearch()"
				>
					<app-icon
						type="svg"
						[size]="16"
						color="currentColor"
						aria-hidden="true"
					>
						search
					</app-icon>
					<typography
						variant="p/xs_medium"
						class="rail-search__label"
					>
						Search
					</typography>
					<kbd class="rail-search__shortcut" aria-hidden="true">
						{{ searchShortcutLabel }}
					</kbd>
				</button>

				<button
					type="button"
					class="rail-toggle"
					(click)="toggleRail()"
					[matTooltip]="
						railCollapsed ? 'Expand menu' : 'Collapse menu'
					"
					matTooltipPosition="right"
					[attr.aria-label]="
						railCollapsed ? 'Expand menu' : 'Collapse menu'
					"
					[attr.aria-expanded]="!railCollapsed"
				>
					<app-icon type="svg" [size]="18" color="currentColor">
						bar_left
					</app-icon>
				</button>
			</div>
			<!--
				Hover and selection used to be the SAME class, so the row you were
				pointing at and the page you were on looked identical. They are
				separate now: hover is plain CSS on :hover, selection is
				.is-selected. The hoverOver flag stays because the Social
				Listening flyout reads it.

				There were also TWO [ngStyle] bindings on the row, which Angular
				resolves by keeping the last — so the 5px accent stripe the first
				one applied had never rendered at all. Both are gone; a side
				stripe is not how this rail says where you are.
			-->
			<mat-list
				class="menu-item-list"
				[class.hidden]="mainItem.hideOnMobile"
				*ngFor="let mainItem of filteredMenuList; let i = index"
			>
				<mat-list-item
					#menuItem
					(click)="
						anaFacade.collapse();
						mainItem.slDynamic
							? onSlClick(menuItem)
							: mainItem.children?.length
							? openChildrenMenu(menuItem, i)
							: menuItemTrigger(i)
					"
					(mouseleave)="
						mouseLeaveMenu(i);
						mainItem.slDynamic && onSlMouseLeave()
					"
					(mouseenter)="
						mouseEnterMenu(i);
						mainItem.slDynamic && onSlMouseEnter(menuItem)
					"
					[ngClass]="{
						'mat-list-item-content-expanded': expandMenu,
						'is-selected':
							(mainItem.isSelected && !mainItem.childOpen) ||
							(mainItem.childOpen && !expandMenu),
						'is-open': isSubmenuOpen(i)
					}"
					class="menu-item"
					[matTooltip]="railCollapsed ? mainItem.title : ''"
					matTooltipPosition="right"
					id="{{ 'side-' + mainItem.name }}"
				>
					<!--
						app-icon rather than an img with a filter chain. The mark
						used to be recoloured by
						brightness(0) saturate(100%) invert(20%) sepia(97%)
						saturate(4171%) hue-rotate(206deg) — a value nobody can
						read, that only approximates the brand blue, and that has
						to be re-derived for every new colour. app-icon renders a
						tinted icon as a CSS mask, so currentColor carries it and
						the row's own hover and selected ink reach the glyph for
						free.
					-->
					<app-icon
						class="route-icon"
						type="svg"
						[size]="20"
						color="currentColor"
					>
						{{ mainItem.iconAlias }}
					</app-icon>
					<span class="route-text">{{ mainItem.title }}</span>
					<!--
						Present only for the one item that has a submenu, so a
						row without children carries nothing on its right edge.
					-->
					<app-icon
						*ngIf="hasSubmenu(mainItem)"
						class="route-chevron"
						[class.route-chevron--open]="isSubmenuOpen(i)"
						type="svg"
						[size]="14"
						color="currentColor"
					>
						small_arrow_down
					</app-icon>
				</mat-list-item>

				<!--
					The row's children, in the list rather than in a flyout
					pinned to its edge. Indented under the parent so the
					relationship is the layout's job and not something the
					reader has to remember.
				-->
				<div
					class="submenu"
					*ngIf="isSubmenuOpen(i) && !railCollapsed"
					@submenuExpand
				>
					<button
						type="button"
						class="submenu-item"
						*ngFor="let child of openSubmenuItems; let ci = index"
						[class.submenu-item--active]="activeSubmenuIndex === ci"
						[class.submenu-item--disabled]="child.disabled"
						[disabled]="child.disabled"
						[matTooltip]="child.tooltip || ''"
						matTooltipPosition="right"
						(click)="onSubmenuItemClick(child)"
					>
						<app-icon type="svg" [size]="16" color="currentColor">
							{{ child.icon }}
						</app-icon>
						<span class="submenu-item__label">
							{{ child.title }}
						</span>
					</button>
				</div>
			</mat-list>
		</div>
	</mat-sidenav>
</section>

<section
	[ngClass]="{
		'side-container-wide': expandMenu,
		'rail-collapsed': railCollapsed
	}"
	class="side-container closed {{ showSidenav ? '' : 'hide-m-r' }}"
>
	<div
		*ngIf="showSidenav"
		[ngClass]="{ 'header-wide': expandMenu }"
		class="header closed"
	>
		<mat-toolbar class="header_toolbar">
			<div (click)="redirectToHome()" class="top-logo-img cursor-pointer">
				<img src="assets/icons/nav-menu/header/lolly-black-logo.svg" />
			</div>

			<div class="header_icons">
				<!-- The credit balance rides in the shell so it is on screen on
				     every page that can start a metered action, without going
				     into billing to look for it. It reads from the shared
				     balance store, which re-reads after a spend.

				     The low-credit warning hangs off the same slot: it is about
				     this chip, so it points at it and overlays the page instead
				     of pushing every screen down by its own height. -->
				<div
					class="credit-chip-slot"
					[class.credit-chip-slot--beside-panel]="
						(anaFacade.visible$ | async) &&
						(anaFacade.slotHolder$ | async) !== 'page' &&
						!(anaFacade.expanded$ | async)
					"
					[class.credit-chip-slot--over-fullscreen]="
						(anaFacade.visible$ | async) &&
						(anaFacade.slotHolder$ | async) !== 'page' &&
						(anaFacade.expanded$ | async)
					"
					[style.--credit-banner-panel-width.px]="
						anaFacade.width$ | async
					"
				>
					<app-credit-balance-indicator></app-credit-balance-indicator>
					<app-credit-low-balance-banner></app-credit-low-balance-banner>
				</div>
				<!-- Which surface is drawing the conversation, in the DOM: the rule
				     it stands for is invisible otherwise, and a spec asserting the
				     panel's absence cannot tell "suppressed" from "not built yet". -->
				<span
					class="ana-slot-holder"
					hidden
					[attr.data-ana-slot-holder]="anaFacade.slotHolder$ | async"
				></span>
				<ng-container *ngIf="!userStatesService.hintsDisabled">
					<div class="hints-wrapper animation-fade-in">
						<text
							style="
								color: #888;
								font-size: 0.875rem;
								font-style: normal;
								font-weight: 500;
								line-height: 1.25rem;
							"
						>
							Hints
						</text>
						<app-on-off-toggle
							(changeChecked)="toggleHints($event)"
							[checkedValue]="userStates.value.show_hints"
						></app-on-off-toggle>
					</div>
					<div class="vertical-line"></div>
				</ng-container>
				<app-skeleton-loader
					*ngIf="isBalanceLoading"
					style="width: 2rem"
					height="2rem"
					borderRadius="0.625rem"
				></app-skeleton-loader>

				<!--
					The cluster's ONE divider, and it earns its place: everything
					to its left is the product (what you have, what you can ask),
					everything to its right is your account. It used to sit
					between Ask Ana and the hints toggle, separating nothing.
				-->
				<span
					*ngIf="!isBalanceLoading"
					class="header-group-divider"
					aria-hidden="true"
				></span>

				<!--
					A button, not a div with a click: this and the account control
					below are the shell's only route to tickets and to sign-out,
					and both were unreachable from a keyboard.
				-->
				<button
					type="button"
					*ngIf="!isBalanceLoading"
					class="chrome-btn help-icon-wrapper"
					(click)="openYourTickets()"
					matTooltip="Your Tickets"
					aria-label="Your Tickets"
				>
					<app-icon type="svg" [size]="18" color="currentColor">
						chrome_help
					</app-icon>
				</button>

				<div
					*ngIf="!isBalanceLoading"
					class="profile-icon-wrapper"
					#settingsIcon
				>
					<button
						type="button"
						class="circle-wrapper"
						[class.circle-wrapper--open]="profileOpen"
						(click)="toggleProfileAction()"
						aria-label="Account menu"
						[attr.aria-expanded]="profileOpen"
					>
						<avatar
							[loading]="allDataLoading"
							[url]="profileImage"
							size="1.5rem"
						></avatar>
					</button>

					<app-profile-menu
						[opened]="profileOpen"
						[fullName]="brandName || userFName + ' ' + userLName"
						[email]="userEmail"
						[planName]="''"
						[resetTimerInSeconds]="resetTimerInSeconds"
						[image]="profileImage"
						[imageLoading]="allDataLoading"
						[isTrial]="false"
						[loading]="getStartedLoading || isBalanceLoading"
						[canManageBilling]="canManageBilling"
						(goToUpgrade)="goToUpgrade()"
						(goToSettings)="goToSettings()"
						(goToTicketCreation)="createTicket()"
						(logout)="logout()"
					></app-profile-menu>
				</div>

				<burger-button
					class="burger-button"
					*ngIf="!isBalanceLoading"
					[isOpen]="burgerMenuOpen"
					(isOpenChange)="toggleBurgerMenu()"
				></burger-button>
			</div>
		</mat-toolbar>
	</div>

	<div
		#mainContainer
		class="main-container closed {{ showSidenav ? '' : 'main-full' }}"
	>
		<mat-sidenav-container>
			<!-- This, not .main-container, is the element that scrolls: Material
			     gives .mat-drawer-content height:100% + overflow:auto and the
			     container above it overflow:hidden, which is also why the
			     non-bubbling (scroll) below is bound here. -->
			<mat-sidenav-content
				#shellScroller
				(scroll)="onScroll($event)"
				[class.shell-scroller-locked]="shellScrollLocked"
			>
				<div
					class="shell-content-row"
					[style.--shell-content-bg]="shellBackground"
					[class.shell-content-row--panel-detached]="panelDetached"
					[style.--shell-panel-reserved-width.px]="
						anaFacade.pushedWidth$ | async
					"
				>
					<div class="shell-content-main" #shellContentMain>
						<router-outlet></router-outlet>
						<app-lolly-spinning-loader
							[rotating]="true"
							class="loading-indicator"
							*ngIf="showSpinner"
						></app-lolly-spinning-loader>
					</div>
					<!-- Built only once the panel has something to show: closed
					     from a previous session means no host element at all,
					     so nothing can flash at full width before the collapse
					     binding lands. Stays mounted after a close so the
					     slide-out animates and the chat survives. -->
					<app-ana-assistant-panel
						*ngIf="
							(anaFacade.rendered$ | async) &&
							(anaFacade.slotHolder$ | async) !== 'page'
						"
						class="shell-ana-panel"
						[class.shell-ana-panel--hidden]="
							!(anaFacade.visible$ | async)
						"
						[class.shell-ana-panel--resizing]="
							anaFacade.resizing$ | async
						"
						[class.shell-ana-panel--overlay]="
							(anaFacade.overlay$ | async) &&
							!(anaFacade.expanded$ | async)
						"
						[class.shell-ana-panel--fullscreen]="
							(anaFacade.expanded$ | async) &&
							(anaFacade.visible$ | async)
						"
						[class.shell-ana-panel--covering]="panelDetached"
						[style.--ana-panel-width.px]="
							(anaFacade.visible$ | async)
								? (anaFacade.width$ | async)
								: 0
						"
						[style.--ana-content-width.px]="
							anaFacade.width$ | async
						"
					></app-ana-assistant-panel>
				</div>
				<app-ana-page-composer
					[insetHost]="mainContainer"
					[style.--shell-content-bg]="shellBackground"
				></app-ana-page-composer>
			</mat-sidenav-content>
		</mat-sidenav-container>
	</div>
</section>

<app-burger-menu
	@slideInDown
	*ngIf="burgerMenuOpen"
	[fullName]="brandName || userFName + ' ' + userLName"
	[email]="userEmail"
	[planName]="''"
	[resetTimerInSeconds]="resetTimerInSeconds"
	[image]="profileImage"
	[imageLoading]="allDataLoading"
	[isTrial]="false"
	[loading]="getStartedLoading || isBalanceLoading"
	[canManageBilling]="canManageBilling"
	(goToUpgrade)="goToUpgrade()"
	(goToSettings)="goToSettings()"
	(goToKnowledgeBase)="openKnowledgeBase()"
	(goToTicketCreation)="createTicket()"
	(logout)="logout()"
	(navigate)="navigate($event)"
></app-burger-menu>

<app-hints></app-hints>
